import React from 'react'

import { Button, useMediaQueryContext } from '@fourthwall/components'

import * as S from './AddMembersOnlyAudio.styled'

type AddMembersOnlyAudioProps = {
  onClick: () => void
}

export const AddMembersOnlyAudio = ({ onClick }: AddMembersOnlyAudioProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <S.Inner>
        <S.Shape style={{ width: '100%', aspectRatio: '1/1' }} />
        <S.Info>
          <S.Shape style={{ height: 21, width: '90%' }} />
          <S.Shape style={{ height: 21, width: '80%' }} />
          <S.Shape style={{ height: 21, width: '90%' }} />
          <S.Shape style={{ height: 21, width: '70%' }} />
        </S.Info>
      </S.Inner>
      <S.ButtonContainer>
        <Button
          label={media.tablet ? 'Add members-only audio to Spotify' : 'Add members-only audio'}
          appearance="primary"
          onClick={onClick}
        />
      </S.ButtonContainer>
    </S.Container>
  )
}
